import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import * as rdrLocales from 'react-date-range/dist/locale';

import CustomIcon from '../common/CustomIcon';
import * as taskActions from '../../actions/taskActions';
import { I18n } from 'react-redux-i18n-lite';
import { SearchBar } from '@netexknowledge/smart-components';

class TaskFilterOptions extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.updateKeywords = this.updateKeywords.bind(this);
    this.handleKeywordsSubmit = this.handleKeywordsSubmit.bind(this);
    this.state = {
      openDatePicker: false,
      keywords: '',
      dateRangePicker: {
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection'
      }
    };
  }

  static propTypes = {
    handleDatesFilter: PropTypes.any,
    keywordsFilter: PropTypes.string,
    datesRangeFilter: PropTypes.object,
    taskActions: PropTypes.object,
    hide: PropTypes.bool,
    locale: PropTypes.string
  };

  handleDatesUpdate(item) {
    const { taskActions } = this.props;

    if (item.selection.endDate > item.selection.startDate) {
      taskActions.setTasksDatesRangeFilter({ startDate: item.selection.startDate, endDate: item.selection.endDate });
      this.setState({ openDatePicker: false });
    } else {
      this.setState({ dateRangePicker: item.selection });
    }
  }

  handleKeywordsSubmit() {
    const { keywords } = this.state;
    const { taskActions } = this.props;

    taskActions.setTasksKeywordsFilter(keywords);
  }

  handleCloseSearchBar() {
    const { taskActions } = this.props;

    taskActions.setTasksKeywordsFilter('');
  }

  updateKeywords(keywords = '') {
    this.setState({ keywords });
  }

  render() {
    const { hide, locale } = this.props;
    const { openDatePicker } = this.state;

    if (hide) {
      return <div />;
    }

    return (
      <div className="tasks-filters-container" tabIndex="-2">
        <SearchBar
          onQueryChange={e => this.updateKeywords(e)}
          onSubmit={this.handleKeywordsSubmit}
          onCloseSearchBar={() => this.handleCloseSearchBar()}
        />
        <div className="task-filter">
          <CustomIcon
            name="filter"
            classes={`filter-icon ${openDatePicker && 'active'}`}
            size={16}
            onClick={() => this.setState({ openDatePicker: !openDatePicker })}
          />
          {Boolean(openDatePicker) && (
            <DateRange
              locale={rdrLocales[locale && locale.split('-')[0]]}
              editableDateInputs={true}
              onChange={item => this.handleDatesUpdate(item)}
              moveRangeOnFirstSelection={false}
              ranges={[this.state.dateRangePicker]}
            />
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    datesRangeFilter: state.task.datesRangeFilter,
    keywordsFilter: state.task.keywordsFilter,
    locale: state.i18n.locale
  };
}

function mapDispatchToProps(dispatch) {
  return {
    taskActions: bindActionCreators(taskActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TaskFilterOptions);
